<cm-preloader *ngIf="!isFormLoaded"></cm-preloader>
<div #cardContainer></div>
<div class="error" *ngIf="errorToShow">
    <div>{{ errorToShow }}</div>
    <div *ngFor="let error of errors">{{ error.message }}</div>
</div>
